const translations = {
    pt: {
        editChapters: 'Editar Capítulos',
        backToChapterSelection: 'Voltar para seleção de Capítulo',
        failedToLoadData: 'Falha ao carregar dados',
        failedToLoadChapterData: 'Falha ao carregar dados do capítulo',
        chapterUpdatedSuccessfully: 'Capítulo atualizado com sucesso',
        failedToUpdateChapter: 'Falha ao atualizar capítulo',
        commentDeleted: 'Comentário excluído com sucesso',
        commentProcessed: 'Comentário processado com sucesso',
        failedToUpdateComment: 'Falha ao atualizar comentário',
        selectResponsibleEditor: 'Selecione um editor responsável',
        taskCreatedSuccessfully: 'Tarefa criada com sucesso',
        failedToCreateTask: 'Falha ao criar tarefa',
        taskMarkedAs: 'Tarefa marcada como',
        failedToUpdateTask: 'Falha ao atualizar tarefa',
        selectAChapter: 'Selecione um capítulo',
        book: 'Livro',
        visible: 'Visível',
        hidden: 'Oculto',
        save: 'Salvar',
        hideChapter: 'Ocultar Capítulo',
        publishChapter: 'Publicar Capítulo',
        editText: 'Editar Texto',
        tasks: 'Tarefas',
        properties: 'Propriedades',
        title: 'Título',
        responsible: 'Responsável',
        suggestions: 'Sugestões',
        delete: 'Excluir',
        createNewTask: 'Criar Nova Tarefa',
        selectEditor: 'Selecionar Editor',
        instructions: 'Instruções...',
        createTask: 'Criar Tarefa',
        chapterTasks: 'Tarefas do Capítulo',
        backToChapterEditing: 'Voltar para edição de Capítulos',
        openTask: 'Tarefa Aberta',
        waitingForReview: 'Aguardando Revisão',
        closedTasks: 'Tarefas Fechadas',
        preview: 'Visualizar',
        reopen: 'Reabrir',
        close: 'Fechar',
        created: 'Criado',
        none: 'Nenhuma',
        relatedComments: 'Comentários Relacionados',
        by: 'por',
        pageNumber: 'Página: ',
        context: 'Contexto',
        contextPlanceholder: 'Forneça contexto aqui...',
        showing: "Mostrando",
        of: " de ",
        commentsLow: "comentários",
    },
    en: {
        editChapters: 'Edit Chapters',
        backToChapterSelection: 'Back to Chapter Selection',
        failedToLoadData: 'Failed to load data',
        failedToLoadChapterData: 'Failed to load chapter data',
        chapterUpdatedSuccessfully: 'Chapter updated successfully',
        failedToUpdateChapter: 'Failed to update chapter',
        commentDeleted: 'Comment deleted successfully',
        commentProcessed: 'Comment processed successfully',
        failedToUpdateComment: 'Failed to update comment',
        selectResponsibleEditor: 'Select a responsible editor',
        taskCreatedSuccessfully: 'Task created successfully',
        failedToCreateTask: 'Failed to create task',
        taskMarkedAs: 'Task marked as',
        failedToUpdateTask: 'Failed to update task',
        selectAChapter: 'Select a chapter',
        book: 'Book',
        visible: 'Visible',
        hidden: 'Hidden',
        save: 'Save',
        hideChapter: 'Hide Chapter',
        publishChapter: 'Publish Chapter',
        editText: 'Edit Text',
        tasks: 'Tasks',
        properties: 'Properties',
        title: 'Title',
        responsible: 'Responsible',
        suggestions: 'Suggestions',
        delete: 'Delete',
        createNewTask: 'Create New Task',
        selectEditor: 'Select Editor',
        instructions: 'Instructions...',
        createTask: 'Create Task',
        chapterTasks: 'Chapter Tasks',
        backToChapterEditing: 'Back to Chapter Editing',
        openTask: 'Open Task',
        waitingForReview: 'Waiting for Review',
        closedTasks: 'Closed Tasks',
        preview: 'Preview',
        reopen: 'Reopen',
        close: 'Close',
        created: 'Created',
        none: 'None',
        relatedComments: 'Related Comments',
        by: 'by',
        pageNumber: 'Page: ',
        context: 'Context',
        contextPlanceholder: 'Provide context here...',
        showing: "Showing",
        of: " of ",
        commentsLow: "comments",
    },
};

export default translations;